var _ellipse, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgApkBaibolLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 13.8459,
    cy: 13.7632,
    rx: 13.8459,
    ry: 13.7632,
    fill: "#C30000"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4764 14.4711H16.4449C17.0152 14.4711 17.4034 14.6074 17.6214 14.8828C17.8392 15.1634 17.9541 15.5093 17.9468 15.8634C17.9586 16.241 17.8488 16.6124 17.6333 16.9239C17.4243 17.2201 17.0361 17.3594 16.4718 17.3594H11.4764V14.4711ZM7.78876 6.88159V20.6446H16.6928C17.3773 20.651 18.056 20.519 18.6874 20.2565C19.272 20.0164 19.8043 19.6663 20.255 19.2256C20.6909 18.7903 21.0359 18.2739 21.2702 17.706C21.5133 17.1217 21.6371 16.4954 21.6345 15.8634C21.6398 15.232 21.5159 14.6062 21.2702 14.0238C21.0371 13.4716 20.6927 12.9726 20.258 12.5574C19.8084 12.1329 19.2773 11.8024 18.6963 11.5858C18.0596 11.3492 17.3846 11.2308 16.7047 11.2362H11.4764V10.1668H19.9444V6.88159H7.78876Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApkBaibolLogo);
export default __webpack_public_path__ + "static/media/apk-baibol-logo.4ad0d57017403772bf5d30d9a39dffc6.svg";
export { ForwardRef as ReactComponent };